// Auto-generated file.
// Don't edit/delete it manually!

import ADD_COLUMN from './multi-color-icons/components/add-column';
import ARTICLE from './multi-color-icons/components/article';
import CLEAR_ALL_FILTERS from './multi-color-icons/components/clear-all-filters';
import EXCEL from './multi-color-icons/components/excel';
import MARKET_ANALYSIS from './multi-color-icons/components/market-analysis';
import PDF from './multi-color-icons/components/pdf';
import PIVOT_TABLE from './multi-color-icons/components/pivot-table';
import POWER_POINT from './multi-color-icons/components/power-point';
import WORD from './multi-color-icons/components/word';
import ZIP_ICON from './multi-color-icons/components/zip-icon';
import type {ComponentProps, ComponentType} from 'react';

export const ICONS_SVG = {
    'add-column': ADD_COLUMN as ComponentType<ComponentProps<'svg'>>,
    'article': ARTICLE as ComponentType<ComponentProps<'svg'>>,
    'clear-all-filters': CLEAR_ALL_FILTERS as ComponentType<ComponentProps<'svg'>>,
    'excel': EXCEL as ComponentType<ComponentProps<'svg'>>,
    'market-analysis': MARKET_ANALYSIS as ComponentType<ComponentProps<'svg'>>,
    'pdf': PDF as ComponentType<ComponentProps<'svg'>>,
    'pivot-table': PIVOT_TABLE as ComponentType<ComponentProps<'svg'>>,
    'power-point': POWER_POINT as ComponentType<ComponentProps<'svg'>>,
    'word': WORD as ComponentType<ComponentProps<'svg'>>,
    'zip-icon': ZIP_ICON as ComponentType<ComponentProps<'svg'>>,
};

const ICONS = {
    ADD_COLUMN: 'add-column',
    ARTICLE: 'article',
    CLEAR_ALL_FILTERS: 'clear-all-filters',
    EXCEL: 'excel',
    MARKET_ANALYSIS: 'market-analysis',
    PDF: 'pdf',
    PIVOT_TABLE: 'pivot-table',
    POWER_POINT: 'power-point',
    WORD: 'word',
    ZIP_ICON: 'zip-icon',
};

export default ICONS;
